interface FooterCtaProps {
  onEnter: (message: string) => void;
}

export default function FooterCta({ onEnter }: FooterCtaProps) {
  return (
    <section className="relative overflow-hidden border-b border-background-200">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20beige%20gradient%20background%20with%20subtle%20geometric%20line%20pattern%20and%20soft%20grain%20texture%2C%20minimal%20editorial%20poster%20style%2C%20warm%20crimson%20and%20amber%20glow%20accents%2C%20no%20text%2C%20clean%20composition%2C%20high%20detail%2C%20harmonious%20elegant%20minimal%20aesthetic%2C%20wide%20banner%20layout&width=1600&height=700&seq=hl-cta-band&orientation=landscape"
          alt="结尾入口背景"
          title="黑料入口 一键进入 直达链接"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/80 via-background-950/65 to-background-950/45"></div>
      </div>

      <div className="relative mx-auto w-full max-w-[1200px] px-4 py-16 md:px-6 md:py-24">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 px-3 py-1 text-xs text-background-100">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-timer-flash-line"></i>
            </span>
            省去搜索等待时间
          </span>
          <h2 className="mt-5 font-heading text-3xl leading-tight text-background-50 md:text-5xl">
            别翻了，入口就在这里
          </h2>
          <p className="mt-4 text-sm leading-7 text-background-100/90 md:text-base">
            黑料入口秒进与一键进入快速访问都已就位，选一条线路点下去，剩下的交给自动跳转。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <button
              type="button"
              onClick={() => onEnter('已为你打开主线路入口（演示）')}
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm text-background-50 transition hover:bg-primary-600"
            >
              <i className="ri-flashlight-fill text-base"></i>
              一键进入
            </button>
            <a
              href="#entry"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 text-sm text-background-50 transition hover:bg-background-50/10"
            >
              <i className="ri-list-check-2 text-base"></i>
              再看看其它线路
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}